import "./DaAccountCreated.css";
import Button from "@mui/material/Button";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { translateStatic } from "../../hooks/useT/useT";

const DaAccountCreated = () => {
  return (
    <DaPageWrapper
      wrapperClass={"da-accountcreated-card da-page-wrapper"}
      iconType="lock"
      title={<Translate tKey={T_KEYS.DA.ACCOUNT_CREATED.TITLE} />}
      subtitle={<Translate tKey={T_KEYS.DA.ACCOUNT_CREATED.DESCRIPTION} />}
    >
      <Button variant="contained" fullWidth className="da-button da-accountcreated-button">
        {translateStatic(T_KEYS.DA.BUTTON.SIGNIN)}
      </Button>
    </DaPageWrapper>
  );
};

export { DaAccountCreated };
